<template>
  <b-form class="col-md-12">
    <b-row>
      <b-col sm="12">
        <b-alert v-if="FormCompleted" show variant="primary">
          Bahagian ini telah lengkap. ✔
        </b-alert>
        <b-alert v-else show variant="warning">
          Bahagian ini tidak lengkap.
        </b-alert>
        <hr />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6" v-if="others == 'guardian'">
        <b-form-group label="Pertalian Dengan Pemohon" label-for="Relationship">
          <!--
          <b-form-select
            id="Relationship"
            :disabled="Busy == true || Submitted == true"
            v-model="RelationshipId"
          >
          -->
          <b-form-select
            id="Relationship"
            :disabled="Busy == true || Submitted == true"
            v-model="RelationshipId"
            @change="setRelationshipIdV4"
          >
            <DefaultOption />
            <option
              v-for="item in Relationship"
              v-bind:value="item.Id"
              :key="item.Id"
            >
              {{ item.Name | titleCase }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-form-group label-for="FullName">
          <template v-slot:label>
            Nama Seperti Dalam Kad Pengenalan
            <span v-if="!FirstName" class="text-danger">*</span>
            <span v-else>✔</span>
          </template>
          <b-form-input
            type="text"
            :disabled="Busy === true || Submitted === true"
            v-model.trim="FirstName"
            @keyup="replaceInvertedComma()"
            @change="replaceInvertedComma()"
          ></b-form-input>
        </b-form-group>
        <span
          class="error"
          v-show="FirstName && !replaceInvertedComma()"
        >
          <span style="color:red;">Nama tidak boleh mengandungi digit</span>
          <hr />
        </span>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col sm="6">
        <b-form-group label-for="Nationality">
          <template v-slot:label>
            Kewarganegaraan
            <span v-if="NationalityId == 0" class="text-danger">*</span>
            <span v-else>✔</span>
          </template>
          <b-form-select
            :disabled="Busy === true || Submitted === true"
            v-model="NationalityId"
          >
            <DefaultOption />
            <option value="130">Warganegara</option>
            <option value="-1">Bukan Warganegara</option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <template
      v-if="
        others == 'spouse' ||
        others == 'father' ||
        others == 'mother' ||
        (others == 'guardian' &&
          RelationshipId != 16 &&
          RelationshipId != 17 &&
          NationalityId != 0)
      "
    >
      <b-row>
        <b-col sm="6" v-if="NationalityId == 130">
          <b-form-group label-for="IC">
            <template v-slot:label>
              No. Kad Pengenalan Baru
              <span
                v-if="!IdentityNo || !IsIdentityValidLocal(IdentityNo)"
                class="text-danger"
                >*</span
              >
              <span v-else>✔</span>
            </template>
            <b-form-input
              type="text"
              placeholder="Cth: 910821045224"
              autocomplete="ic"
              :disabled="Busy === true || Submitted === true"
              v-model.trim="IdentityNo"
              maxlength="12"
            ></b-form-input>
            <span
              class="error"
              v-show="IdentityNo && !IsIdentityValidLocal(IdentityNo)"
            >
              <span style="color: red">No. Kad Pengenalan tidak sah</span>
              <hr />
            </span>
          </b-form-group>
        </b-col>
        <b-col sm="6" v-if="NationalityId == -1">
          <b-form-group label-for="Passport">
            <template>
              No. Pasport
              <span v-if="!PassportNo" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
            <b-form-input
              type="text"
              placeholder="Cth: A34637411"
              :disabled="Busy === true || Submitted === true"
              v-model.trim="PassportNo"
              maxlength="12"
            ></b-form-input>
            <!-- <span class="error" v-show="IdentityNo && !IsIdentityValidLocal(IdentityNo)">
              <span style="color:red;">No. Kad Pengenalan tidak sah</span>
              <hr />
            </span> -->
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label-for="IC Other">
            <template v-slot:label>
              No. Kad Pengenalan (Lama / Tentera / Lain-lain)
              <span
                v-if="wasBornBefore1977(IdentityNo) && !IdentityNoOther"
                class="text-danger"
                >*</span
              >
              <span v-else-if="wasBornBefore1977(IdentityNo) && IdentityNoOther">✔</span>
            </template>
            <b-form-input
              type="text"
              placeholder="Cth: 910821045224"
              autocomplete="ic"
              :disabled="Busy === true || Submitted === true"
              v-model="IdentityNoOther"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6" v-if="NationalityId == 130">
          <b-form-group label="Tarikh Lahir" label-for="DateOfBirth">
            <b-form-input type="date" disabled v-model="BirthDt"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6" v-if="NationalityId == -1" >
          <b-form-group label="Tarikh Lahir" label-for="DateOfBirth">
            <b-form-input type="date" v-model="BirthDt"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <hr />
      <!--
      <b-row>
        <b-col sm="6">
          <b-form-group label-for="FullName">
            <template v-slot:label>
              Nama Seperti Dalam Kad Pengenalan
              <span v-if="!FirstName" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
            <b-form-input
              type="text"
              :disabled="Busy === true || Submitted === true"
              v-model.trim="FirstName"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <hr />
      -->
      <b-row>
        <!-- <b-col sm="6">
          <b-form-group label-for="Nationality">
            <template v-slot:label>
              Kewarganegaraan
              <span v-if="NationalityId == 0" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
            <b-form-select :disabled="Busy === true || Submitted === true" v-model="NationalityId">
              <DefaultOption />
              <option value="130">Warganegara</option>
              <option value="-1">Bukan Warganegara</option>
            </b-form-select>
          </b-form-group>
        </b-col> -->
        <!--
        <b-col sm="6">
          <b-form-group label-for="Religion">
            <template v-slot:label>
              Agama
              <span v-if="ReligionId == 0" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
            <b-form-select
              :disabled="Busy === true || Submitted === true"
              v-model="ReligionId"
            >
              <DefaultOption />
              <option
                v-for="item in Religions"
                v-bind:value="item.Id"
                :key="item.Id"
              >
                {{ item.Name | titleCase }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
        -->
        
        <b-col sm="6">
          <b-form-group label-for="Religion">
            <template v-slot:label>
              Agama
              <span v-if="ReligionId == 0" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
            <Dropdown v-model="ReligionName" :options="Religions" optionLabel="Name" @change="setReligionId($event)" :filter="true" placeholder="Sila Pilih" :showClear="true" 
              :disabled="Busy === true || Submitted === true"
              dataKey="Id" class="p-inputtext-sm" style="width:100%; box-sizing: border-box;" inputStyle="width: 100%; box-sizing: border-box;">
              <template #value="slotProps">
                <div v-if="slotProps.value">
                  <div>{{slotProps.value.Name}}</div>
                </div>
                <span v-else>
                  {{slotProps.placeholder}}
                </span>
              </template>
              <template #option="slotProps">
                <div>
                  <div>{{slotProps.option.Name}}</div>
                </div>
              </template>
            </Dropdown>
          </b-form-group>
        </b-col>
        
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group label-for="CountryOfBirth">
            <template v-slot:label>
              Negara Lahir
              <span v-if="BirthCountryId == 0" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
            <!--
            <b-form-select
              :disabled="Busy === true || Submitted === true"
              v-model="BirthCountryId"
            >
              <DefaultOption />
              <option
                v-for="item in Countries"
                v-bind:value="item.Id"
                :key="item.Id"
              >
                {{ item.Name | titleCase }}
              </option>
            </b-form-select>
            -->
            
            <Dropdown v-model="BirthCountryName" :options="Countries" optionLabel="Name" @change="setBirthCountryId($event)" :filter="true" placeholder="Sila Pilih" :showClear="true" 
              :disabled="Busy === true || Submitted === true"
              dataKey="Id" class="p-inputtext-sm" style="width:100%; box-sizing: border-box;" inputStyle="width: 100%; box-sizing: border-box;">
              <template #value="slotProps">
                <div v-if="slotProps.value">
                  <div>{{slotProps.value.Name}}</div>
                </div>
                <span v-else>
                  {{slotProps.placeholder}}
                </span>
              </template>
              <template #option="slotProps">
                <div>
                  <div>{{slotProps.option.Name}}</div>
                </div>
              </template>
            </Dropdown>
            
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label-for="StateOfBirth">
            <template v-if="BirthCountryId == 0" v-slot:label>
              Negeri Lahir
              <span class="text-danger">*</span>
            </template>
            <template v-else-if="BirthCountryId == 130" v-slot:label>
              Negeri Lahir
              <span v-if="BirthStateId == 0" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
            <template
              v-else-if="BirthCountryId != 0 && BirthCountryId != 130"
              v-slot:label
            >
              Negeri Lahir
              <span v-if="!OtherBirthStateName" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
            <div v-if="BirthCountryId == 130">
              <!--
              <b-form-select
                :disabled="Busy == true || Submitted == true"
                v-model="BirthStateId"
              >
                <DefaultOption />
                <option
                  v-for="item in States"
                  v-bind:value="item.Id"
                  :key="item.Id"
                >
                  {{ item.Name | titleCase }}
                </option>
              </b-form-select>
              -->
              <Dropdown v-model="BirthStateName" :options="States" optionLabel="Name" @change="setBirthStateId($event)" :filter="true" placeholder="Sila Pilih" :showClear="true" 
                :disabled="Busy === true || Submitted === true"
                dataKey="Id" class="p-inputtext-sm" style="width:100%; box-sizing: border-box;" inputStyle="width: 100%; box-sizing: border-box;">
                <template #value="slotProps">
                  <div v-if="slotProps.value">
                    <div>{{slotProps.value.Name}}</div>
                  </div>
                  <span v-else>
                    {{slotProps.placeholder}}
                  </span>
                </template>
                <template #option="slotProps">
                  <div>
                    <div>{{slotProps.option.Name}}</div>
                  </div>
                </template>
              </Dropdown>
            </div>
            <div v-else>
              <b-form-input
                id="StateOfBirth"
                type="text"
                placeholder="Contoh : London"
                :disabled="Busy == true || Submitted == true"
                v-model.trim="OtherBirthStateName"
                v-if="null!=OtherBirthStateName && 0==OtherBirthStateName.length"
              ></b-form-input>
              <b-form-input
                id="StateOfBirth"
                type="text"
                placeholder="Contoh : London"
                :disabled="Busy == true || Submitted == true"
                v-model.trim="OtherBirthStateName"
                readonly
                v-else
              ></b-form-input>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group label-for="Race">
            <template v-slot:label>
              Bangsa
              <span v-if="RaceId == 0" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
            <b-form-select
              :disabled="Busy === true || Submitted === true"
              v-model="RaceId"
              @change="EthnicId = 0"
            >
              <DefaultOption />
              <option
                v-for="item in Races"
                v-bind:value="item.Id"
                :key="item.Id"
              >
                {{ item.Name | titleCase }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <div>
            <b-form-group label-for="EthnicFreeText">
              <template v-slot:label>
                Keturunan
              </template>
              <b-form-input
                v-model.trim="EthnicFreeText"
                class="mt-2"
                type="text"
                :disabled="Busy == true || Submitted == true"
                placeholder="Sila nyatakan"
              ></b-form-input>
            </b-form-group>
          </div>
        </b-col>
        <!--
        <b-col sm="6">
          <div v-if="RaceId != 0">
            <b-form-group label-for="Ethnic">
              <template v-slot:label>
                Keturunan
                <span v-if="EthnicId == 0" class="text-danger">*</span>
                <span v-else>✔</span>
              </template>
              <b-form-select
                :disabled="Busy == true || Submitted == true"
                v-model="EthnicId"
              >
                <DefaultOption />
                <option
                  v-for="item in Ethnics"
                  v-bind:value="item.Id"
                  :key="item.Id"
                >
                  {{ item.Name | titleCase }}
                </option>
              </b-form-select>
            </b-form-group>
          </div>
        </b-col>
        -->
      </b-row>
      <hr />
      <b-row>
        <!--
        <b-col sm="6">
          <b-form-group label-for="IsDisable">
            <template v-slot:label>
              Taraf OKU
              <span v-if="DisabilityStatus == 0" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
            <b-form-select
              :plain="true"
              :disabled="Busy === true || Submitted === true"
              v-model="DisabilityStatus"
            >
              <DefaultOption />
              <option value="1">Ya</option>
              <option value="2">Tidak</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        -->
        <b-col sm="6" v-if="others == 'father' || others == 'mother'">
          <b-form-group label-for="IsLiving">
            <template v-slot:label>
              Status
              <span v-if="LivingStatus == 0" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
            <b-form-select
              :plain="true"
              :disabled="Busy === true || Submitted === true"
              v-model="LivingStatus"
            >
              <DefaultOption />
              <option value="1">Hidup</option>
              <option value="2">Meninggal Dunia</option>
              <option value="3">Tidak diketahui</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </b-form>
</template>

<script>
import DefaultOption from "./DefaultOption";
import _ from "lodash";
import Vue from "vue";
import PrimeVue from 'primevue/config';
Vue.use(PrimeVue);
import Dropdown from 'primevue/dropdown';

export default {
  name: "OthersPersonalDetails",
  props: ["others"],
  components: {
    DefaultOption,
    Dropdown,
  },
  data: function () {
    return {
      info: {},
      API: {},

      Relationship: {},
      race: {},
      ethnic: {},
      religion: {},
      BirthCountryName: null,
      BirthStateName: null,
      ReligionName: null,
      sCFN: 'OthersPersonalDetails: ',
    };
  },
  async mounted() {
    let fN = 'mounted: ';
    let isAuth = await this.UserAuth();
    if (isAuth) {
      //this.HTECHLogger(this.sCFN + fN + 'this.others = ' + this.others)
      this.GetRelationship();
      await this.GetDetails();
      //this.HTECHLogger(this.sCFN + fN + 'this.Countries = ' + JSON.stringify(this.Countries))
      //this.HTECHLogger(this.sCFN + fN + 'this.States = ' + JSON.stringify(this.States))
      //this.HTECHLogger(this.sCFN + fN + 'this.Religions = ' + JSON.stringify(this.Religions))
    }
  },
  computed: {
    FormCompleted: {
      get: function () {
        let fN = 'FormCompleted: ';
        let complete = true;

        if (this.others == "guardian") {
          if (this.RelationshipId == 16 || this.RelationshipId == 17) {
            this.$store.dispatch(
              this.others + "PersonalDetails/updateFormCompleted",
              complete
            );
            return complete;
          }
        }

        if (
          this.FirstName &&
          // !this.IdentityNo &&
          // !this.PassportNo &&
          this.NationalityId != 0 &&
          this.ReligionId != 0 &&
          this.BirthCountryId != 0 &&
          this.RaceId != 0 //&&
          //this.EthnicId != 0 &&
          //this.DisabilityStatus != 0
        ) {
          if (this.BirthCountryId == 130) {
            if (this.BirthStateId == 0) complete = false;
          } else {
            if (!this.OtherBirthStateName) complete = false;
          }
        } else {
          complete = false;
        }

        if (130 == this.NationalityId) {
          if (this.IdentityNo && !this.IsIdentityValidLocal(this.IdentityNo))
            complete = false;
        }

        if (this.others == "father" || this.others == "mother") {
          if (this.LivingStatus == 0) complete = false;
        }

        if (130 == this.NationalityId) {
          if  ((null != this.IdentityNo)
            && (0 == this.IdentityNo.length))
            complete = false;
        } else {
          if  ((null != this.PassportNo)
            && (0 == this.PassportNo.length))
            complete = false;
        }

        if (130 == this.NationalityId) {
          if  ((null != this.IdentityNo)
            && (0 < this.IdentityNo.length)) {
            if (this.wasBornBefore1977(this.IdentityNo)) {
              if (null == this.IdentityNoOther) {
                complete = false;
              } else {
                if (0 == this.IdentityNoOther.length) {
                  complete = false;
                }
              }
            }
          }
        }

        this.$store.dispatch(
          this.others + "PersonalDetails/updateFormCompleted",
          complete
        );
        return complete;
      },
    },
    Busy: {
      get: function () {
        return this.$store.getters["common/Busy"];
      },
      set: function (value) {
        this.$store.dispatch("common/updateBusy", value);
      },
    },
    Submitted: {
      get: function () {
        return this.$store.getters["common/Submitted"];
      },
    },
    RelationshipId: {
      get: function () {
        return this.$store.getters[
          this.others + "PersonalDetails/Relationship"
        ];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateRelationship",
          value
        );
      },
    },
    IdentityNo: {
      get: function () {
        return this.$store.getters[this.others + "PersonalDetails/IdentityNo"];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateIdentityNo",
          value
        );
      },
    },
    PassportNo: {
      get: function () {
        return this.$store.getters[this.others + "PersonalDetails/PassportNo"];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updatePassportNo",
          value
        );
      },
    },
    IdentityNoOther: {
      get: function () {
        return this.$store.getters[
          this.others + "PersonalDetails/IdentityNoOther"
        ];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateIdentityNoOther",
          value
        );
      },
    },
    SexId: {
      get: function () {
        return this.$store.getters[this.others + "PersonalDetails/Sex"];
      },
      set: function (value) {
        this.$store.dispatch(this.others + "PersonalDetails/updateSex", value);
      },
    },
    BirthDt: {
      //let nationality = this.$store.getters[this.others + "PersonalDetails/Nationality"],
      get: function () {
        let nationality = this.$store.getters[this.others + "PersonalDetails/Nationality"];

        if (nationality == 130) {
          var identityNo =
            this.$store.getters[this.others + "PersonalDetails/IdentityNo"];

          if (identityNo === null || identityNo === undefined) return;
          if (identityNo.length != 12) return;

          var birthYear = identityNo.substring(0, 2);
          var birthMonth = identityNo.substring(2, 4);
          var birthDay = identityNo.substring(4, 6);

          var yearInt = parseInt(birthYear);

          if (yearInt >= 30) birthYear = "19" + birthYear;
          else birthYear = "20" + birthYear;

          if (identityNo != null)
            return this.moment(birthYear + birthMonth + birthDay).format(
              "YYYY-MM-DD"
            );

          return this.$store.getters[this.others + "PersonalDetails/BirthDt"];
        } 
        else {
          return this.moment(this.$store.getters[
            this.others + "PersonalDetails/BirthDt"
          ]).format("YYYY-MM-DD");
        }
      },
      set: function (value) {
        let nationality = this.$store.getters[this.others + "PersonalDetails/Nationality"];
        if (nationality == 130) {
          var identityNo =
            this.$store.getters[this.others + "PersonalDetails/IdentityNo"];

          if (identityNo === null || identityNo === undefined) return;
          if (identityNo.length != 12) return;

          var birthYear = identityNo.substring(0, 2);
          var birthMonth = identityNo.substring(2, 4);
          var birthDay = identityNo.substring(4, 6);

          var yearInt = parseInt(birthYear);

          if (yearInt >= 30) birthYear = "19" + birthYear;
          else birthYear = "20" + birthYear;

          if (identityNo != null)
            value = this.moment(birthYear + birthMonth + birthDay).format(
              "YYYY-MM-DD"
            );

          this.$store.dispatch(
            this.others + "PersonalDetails/updateBirthDt",
            value
          );
        } 
        else {
          this.$store.dispatch(
            this.others + "PersonalDetails/updateBirthDt",
            value
          );
        }
      },
    },
    FirstName: {
      get: function () {
        if ('guardian' == this.others) {
          if (17 == this.RelationshipIdV4) {
            return this.$store.getters["fatherPersonalDetails/FirstName"];
          }
          if (16 == this.RelationshipIdV4) {
            return this.$store.getters["motherPersonalDetails/FirstName"];
          }
        }
        return this.$store.getters[this.others + "PersonalDetails/FirstName"];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateFirstName",
          value
        );
      },
    },
    NationalityId: {
      get: function () {
        if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
          return this.MotherContactInfo.NationalityId;
        }
        if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
          return this.FatherContactInfo.NationalityId;
        }
        return this.$store.getters[this.others + "PersonalDetails/Nationality"];
      },
      set: function (value) {
        if (16 == this.RelationshipIdV4) {
          this.$store.dispatch("motherPersonalDetails/updateNationality", value);
        } else if (17 == this.RelationshipIdV4) {
          this.$store.dispatch("fatherPersonalDetails/updateNationality", value);
        } else {
          this.$store.dispatch(this.others + "PersonalDetails/updateNationality", value);
        }
      },
    },
    ReligionId: {
      get: function () {
        if (0 != this.$store.getters[this.others + "PersonalDetails/Religion"]) {
          let arr = _.filter(this.Religions, ['Id', this.$store.getters[this.others + "PersonalDetails/Religion"]]);
          if (0 < arr.length) {
            this.ReligionName = {};
            this.ReligionName.Name = arr[0].Name;
          }
        }
        return this.$store.getters[this.others + "PersonalDetails/Religion"];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateReligion",
          value
        );
      },
    },
    BirthCountryId: {
      get: function () {
        if (0 != this.$store.getters[this.others + "PersonalDetails/BirthCountry"]) {
          let arr = _.filter(this.Countries, ['Id', this.$store.getters[this.others + "PersonalDetails/BirthCountry"]]);
          if (0 < arr.length) {
            this.BirthCountryName = {};
            this.BirthCountryName.Name = arr[0].Name;
          }
        }
        return this.$store.getters[this.others + "PersonalDetails/BirthCountry"];
      },
      set: function(value) {
        if ((0 < value)
         && (130 != value)) {
          this.BirthStateId = 20;
          this.OtherBirthStateName = "LAIN-LAIN";
        }
        this.$store.dispatch(this.others + "PersonalDetails/updateBirthCountry", value);
      }
    },
    BirthStateId: {
      get: function () {
        if (0 != this.$store.getters[this.others + "PersonalDetails/BirthState"]) {
          let arr = _.filter(this.States, ['Id', this.$store.getters[this.others + "PersonalDetails/BirthState"]]);
          if (0 < arr.length) {
            this.BirthStateName = {};
            this.BirthStateName.Name = arr[0].Name;
          }
        }
        return this.$store.getters[this.others + "PersonalDetails/BirthState"];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateBirthState",
          value
        );
      },
    },
    OtherBirthStateName: {
      get: function () {
        return this.$store.getters[
          this.others + "PersonalDetails/OtherBirthStateName"
        ];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateOtherBirthStateName",
          value
        );
      },
    },
    RaceId: {
      get: function () {
        return this.$store.getters[this.others + "PersonalDetails/Race"];
      },
      set: function (value) {
        this.$store.dispatch(this.others + "PersonalDetails/updateRace", value);
      },
    },
    EthnicId: {
      get: function () {
        return this.$store.getters[this.others + "PersonalDetails/Ethnic"];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateEthnic",
          value
        );
      },
    },
    EthnicFreeText: {
      get: function () {
        return this.$store.getters[this.others + "PersonalDetails/EthnicFreeText"];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateEthnicFreeText",
          value
        );
      },
    },
    DisabilityStatus: {
      get: function () {
        return this.$store.getters[this.others + "PersonalDetails/Disablity"];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateDisability",
          value
        );
      },
    },
    LivingStatus: {
      get: function () {
        return this.$store.getters[this.others + "PersonalDetails/Living"];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateLiving",
          value
        );
      },
    },
    PersonalAddressId: {
      get: function () {
        return this.$store.getters[
          this.others + "PersonalDetails/PersonalAddress"
        ];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updatePersonalAddress",
          value
        );
      },
    },

    // Common
    Countries: {
      get: function () {
        let arr = this.$store.getters["places/Countries"];
        arr = _.orderBy(arr, ["Name", "asc"]);
        return arr;
      },
    },
    States: {
      get: function() {
        let arr = this.$store.getters["places/States"];
        arr = _.reject(arr, ['Name', 'LAIN-LAIN']);
        arr = _.reject(arr, ['Name', 'Luar Negara']);
        return arr;
      },
    },
    Religions: {
      get: function () {
        let item = this.$store.getters["common/Religions"];
        if (0 < item.length) {
        //if (typeof item === 'object' && item !== null) {
          return item;
        }
        return [];
      },
    },
    Races: {
      get: function () {
        return this.$store.getters["common/Races"];
      },
    },
    Ethnics: {
      get: function () {
        let arr = this.$store.getters["common/Ethnics"];
        let filtered = _.filter(arr, ["RaceId", this.RaceId]);

        return filtered;
      },
    },
    RelationshipIdV4: {
      get: function() {
        return this.$store.getters["appPersonalDetails/RelationshipV4"];
      },
      set: function(value) {
        this.RelationshipId = value;
        this.$store.dispatch("appPersonalDetails/updateRelationshipV4", value);
      }
    },
    FatherContactInfo: {
      get: function() {
        let obj = {};
        obj.FixPhoneNo = this.$store.getters["fatherContactDetails/FixPhoneNo"];
        obj.MobilePhoneNo = this.$store.getters["fatherContactDetails/MobilePhoneNo"];
        obj.FaxNo = this.$store.getters["fatherContactDetails/FaxNo"];
        obj.Email = this.$store.getters["fatherContactDetails/Email"];
        obj.NationalityId = this.$store.getters["fatherPersonalDetails/Nationality"];
        return obj;
      },
    },
    MotherContactInfo: {
      get: function() {
        let obj = {};
        obj.FixPhoneNo = this.$store.getters["motherContactDetails/FixPhoneNo"];
        obj.MobilePhoneNo = this.$store.getters["motherContactDetails/MobilePhoneNo"];
        obj.FaxNo = this.$store.getters["motherContactDetails/FaxNo"];
        obj.Email = this.$store.getters["motherContactDetails/Email"];
        obj.NationalityId = this.$store.getters["motherPersonalDetails/Nationality"];
        return obj;
      },
    },
  },
  methods: {
    IsIdentityValidLocal(identityNo) {
      let fN = 'IsIdentityValidLocal: ';
      if (identityNo === null || identityNo === undefined) { 
        return false;
      }
      if (identityNo.length != 12) {
        return false;
      }
      let isNumber = /^\d+$/.test(identityNo);
      if (false == isNumber) {
        return false;
      }

      var birthYear = identityNo.substring(0, 2);
      var birthMonth = identityNo.substring(2, 4);
      var birthDay = identityNo.substring(4, 6);

      var yearInt = parseInt(birthYear);

      if (yearInt >= 30) birthYear = "19" + birthYear;
      else birthYear = "20" + birthYear;

      let birthDt = this.moment(birthYear + birthMonth + birthDay).format(
        "YYYY-MM-DD HH:mm:ss"
      );

      return this.moment(birthDt).isValid();
    },
    async GetDetails() {
      let fN = 'GetDetails: ';
      return this.$API
        .get(this.$PersonalDetails + "/" + this.others, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.FirstName = this.info.FirstName;
            this.LastName = this.info.LastName;
            this.Title = this.info.Title;
            this.IdentityNo = this.info.IdentityNo;
            this.PassportNo = this.info.PassportNo;
            this.IdentityNoOther = this.info.IdentityNoOther;
            this.BirthDt = this.info.BirthDt;
            this.BirthStateId = this.info.StateOfBirthId;
            let arr = _.filter(this.States, ['Id', this.BirthStateId]);
            if (0 < arr.length) {
              this.BirthStateName = {};
              this.BirthStateName.Name = arr[0].Name;
            }
            this.OtherBirthStateName = this.info.OtherBirthStateName;
            this.BirthCountryId = this.info.CountryOfBirthId;
            arr = _.filter(this.Countries, ['Id', this.BirthCountryId]);
            if (0 < arr.length) {
              this.BirthCountryName = {};
              this.BirthCountryName.Name = arr[0].Name;
            }
            this.NationalityId = this.info.NationalityId;
            this.ReligionId = this.info.ReligionId;
            arr = _.filter(this.Religions, ['Id', this.ReligionId]);
            if (0 < arr.length) {
              this.ReligionName = {};
              this.ReligionName.Name = arr[0].Name;
            }
            this.RaceId = this.info.RaceId;
            this.EthnicId = this.info.EthnicId;
            this.DisabilityStatus = this.info.DisabilityStatus;
            this.AddressId = this.info.AddressId;
            this.LivingStatus = this.info.LivingStatus;
            this.RelationshipId = this.info.RelationshipId;
          } else {
            console.log(this.info.detail);
          }
          console.log('BirthDate: ' + this.others + ': ' + this.BirthDt)
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetRelationship() {
      this.$API
        .get(this.$Relationship, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Relationship = response.data;
          }
        });
    },
    replaceInvertedComma() {
      let fN = 'replaceInvertedComma: ';
      this.FirstName = this.FirstName.replace("`","'");
      const isNumber = /\d/.test(this.FirstName);
      if (true == isNumber) {
        return false;
      } else {
        return true;
      }
    },
    async setBirthCountryId(event) {
      let fN = 'setBirthCountryId: ';
      //this.HTECHLogger(this.sCFN + fN + 'event = ' + JSON.stringify(event))
      if (null !== event.value) {
        this.BirthCountryId = event.value.Id;
        this.BirthCountryName = {};
        this.BirthCountryName.Name = event.value.Name;
      }
      if (null === event.value) {
        this.BirthCountryId = 0;
        this.BirthCountryName = null;
      }
    },
    async setBirthStateId(event) {
      let fN = 'setBirthStateId: ';
      //this.HTECHLogger(this.sCFN + fN + 'event = ' + JSON.stringify(event))
      if (null !== event.value) {
        this.BirthStateId = event.value.Id;
        this.BirthStateName = {};
        this.BirthStateName.Name = event.value.Name;
      }
      if (null === event.value) {
        this.BirthStateId = 0;
        this.BirthStateName = null;
      }
    },
    async setRelationshipIdV4() {
      this.RelationshipIdV4 = this.RelationshipId;
    },
    async setReligionId(event) {
      let fN = 'setReligionId: ';
      //this.HTECHLogger(this.sCFN + fN + 'event = ' + JSON.stringify(event))
      if (null !== event.value) {
        this.ReligionId = event.value.Id;
        this.ReligionName = {};
        this.ReligionName.Name = event.value.Name;
      }
      if (null === event.value) {
        this.ReligionId = 0;
        this.ReligionName = null;
      }
    },
    wasBornBefore1977(identityNo) {
      let fN = 'wasBornBefore1977: ';
      if (!this.IsIdentityValidLocal(identityNo)) {
        return false;
      }
      var birthYear = identityNo.substring(0, 2);
      var yearInt = parseInt(birthYear);
      //this.HTECHLogger(this.sCFN + fN + 'yearInt = ' + yearInt)
      if (yearInt >= 30) 
        birthYear = "19" + birthYear;
      else
        birthYear = "20" + birthYear;
      if (1977 >= parseInt(birthYear)) {
        return true;
      }
      return false;
    },
  },
};
</script>
